var React = require('react');

function PaginateIconArrowR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M423.182,241.343l-.889,1,6.222,7-6.222,7,.889,1,7.111-8Z","transform":"translate(-422.293 -241.343)","fill":"#101010"}));
}

PaginateIconArrowR.defaultProps = {"width":"8","height":"16","viewBox":"0 0 8 16"};

module.exports = PaginateIconArrowR;

PaginateIconArrowR.default = PaginateIconArrowR;
